import { useSelector } from "react-redux";
import type { RootState } from "@src/reducers/store";

export const useIsImexNamespace = (): boolean => {
  const namespace = useSelector(
    (state: RootState) => state.yourSlice.authContext?.customerNamespace,
  );
  if (namespace) {
    return namespace === "3b9d096f-4888-4765-b54d-cde3ac35062f";
  }
  return false;
};
